/* ============================================================================
FILE: po-katupirsia9-loi-d-or-texts-fr-en-es-20260326.js
MODE: manual protected trilingual injection + audio layer
API:  window.PoK9LoiDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='loi_d_or']
ROLE:
  - Bloque les traductions extérieures sur le bloc.
  - Active uniquement la traduction interne via boutons FR / EN / ES.
  - Verrouille le vocabulaire canonique et ses caractères spéciaux.
  - CTA fin de page via slot : cta_translate.
  - Ajoute une lecture audio générale et locale par bloc sans remplacer le système existant.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K9_LOI_D_OR_TEXTS_20260326__) return;
  window.__PO_K9_LOI_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SELECTOR = ".po-axis-section[data-po-axis='loi_d_or']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Loi_d_or_conceptuel.png?v=1773258040";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Loi_d_or_fonctionnel.png?v=1773258041";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "FR";
    }catch(e){
      return "FR";
    }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function nt(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }

  var COPY = {
    FR: {
      title: "Loi d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Principes matriciels, grammaire dorée et syntonie ontologique)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Dans K9, la Loi d’Or relève de la famille canonique X d’Or : un principe, un organe ou un opérateur. Elle est explicitement définie comme loi de syntonie : « tout équilibre est respiration équilibrée ».",
      def_long:
        "<p>Dans la grammaire dorée rattachée à " + nt("Âṣẹxel’Or") + " et au " + nt("Souffle d’Or") + ", la forme canonique " + nt("X d’Or") + " sert à nommer ce qui agit comme principe, organe ou opérateur de cohérence. " + nt("Loi d’Or") + " appartient à cette famille des opérateurs, et non aux qualités de type " + nt("X doré(e)") + " ni aux régimes de type " + nt("Or de X") + ".</p>" +
        "<p>Dans le tableau des principes matriciels de " + nt("Katûpirsia 9") + ", " + nt("Loi d’Or") + " est donnée avec sa fonction posœnnoïale explicite : <em>loi de syntonie : tout équilibre est respiration équilibrée</em>. Son domaine y est précisé comme ontologique.</p>" +
        "<p>Cette formulation situe " + nt("Loi d’Or") + " au point où la proportion, le rythme et le souffle cessent d’être seulement des motifs symboliques pour devenir une règle de tenue du réel. Elle sert d’axe de lecture pour comprendre comment un déséquilibre se réaccorde, comment une tension demeure vivante sans se rompre, et comment la cohérence se maintient par respiration plutôt que par fixité.</p>" +
        "<p>Aucun nombre-guide propre à " + nt("Loi d’Or") + " n’est attesté dans les documents fournis ; la page conserve donc les deux idéogrammes canoniques disponibles.</p>",
      h_features: "Dynamiques attestées",
      h_questions: "Repères d’usage",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "Dans une situation de tension, la Loi d’Or invite à vérifier si l’équilibre recherché relève d’une simple immobilisation ou d’une respiration juste capable de maintenir ensemble cohésion, passage et tenue.",
      features: [
        "Famille canonique : X d’Or = principe, organe, opérateur.",
        "Fonction attestée : loi de syntonie ; tout équilibre est respiration équilibrée.",
        "Domaine attesté : ontologique.",
        "Liens internes directs : Souffle d’Or, Rythme d’Or, Mesure d’Or, au sein des principes matriciels de K9."
      ],
      questions: [
        "Quel déséquilibre demande ici un réaccord respirant plutôt qu’une simple correction ?",
        "La tension en jeu relève-t-elle du rythme, de la mesure, du passage ou de la proportion ?",
        "Quel réglage minimal rend l’équilibre respirable sans figer le mouvement ?",
        "L’acte posé augmente-t-il la syntonie du champ, ou ne fait-il que masquer l’écart ?"
      ],
      family_1: "<p><strong>Grammaire dorée :</strong> " + nt("Loi d’Or") + " relève de la forme canonique " + nt("X d’Or") + ", réservée aux principes, organes et opérateurs. Dans le lexique K9, cette famille sert à nommer ce qui agit comme fonction unifiante ou instrument de cohérence.</p>",
      family_2: "<p><strong>Liens internes :</strong> dans les principes matriciels de K9, " + nt("Loi d’Or") + " se tient aux côtés de " + nt("Souffle d’Or") + ", " + nt("Rythme d’Or") + " et " + nt("Mesure d’Or") + ". Elle en formule la règle ontologique : l’équilibre vrai se tient dans une respiration ajustée, au croisement du φ, du 3–6–9 et de la syntonie du Souffle.</p>",
      word_blocks: [
        { head: "1) Loi", text: "Principe de tenue, d’orientation et de régulation du réel." },
        { head: "2) d’Or", text: "Dans la grammaire dorée de K9, cette forme désigne un opérateur de cohérence, un organe ou un principe unifiant." },
        { head: "3) Loi d’Or", text: "Formule canonique d’un principe de syntonie : l’équilibre y demeure respiration, ajustement et continuité vivante." }
      ],
      word_notes: [
        "Statut lexical : gold_operator / Opérateurs.",
        "Aucun nombre-guide propre à Loi d’Or n’est attesté dans les documents fournis."
      ],
      cta_translate: "Proposer une traduction du concept",
      langbar_aria: "Choix de langue",
      audio_general: "Écouter le texte",
      audio_block: "Écouter ce bloc",
      audio_stop: "Arrêter la lecture"
    },
    EN: {
      title: "Loi d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Matrix principles, golden grammar and ontological syntony)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "In K9, " + "Loi d’Or" + " belongs to the canonical family " + "X d’Or" + ": a principle, an organ or an operator. It is explicitly defined as a law of syntony: “all equilibrium is balanced breathing.”",
      def_long:
        "<p>Within the golden grammar attached to " + nt("Âṣẹxel’Or") + " and " + nt("Souffle d’Or") + ", the canonical form " + nt("X d’Or") + " names what acts as a principle, an organ or an operator of coherence. " + nt("Loi d’Or") + " belongs to this family of operators, not to qualities of the type " + nt("X doré(e)") + " nor to regimes of the type " + nt("Or de X") + ".</p>" +
        "<p>In the table of matrix principles of " + nt("Katûpirsia 9") + ", " + nt("Loi d’Or") + " is given with its explicit posœnnoïal function: <em>law of syntony: all equilibrium is balanced breathing</em>. Its domain is specified there as ontological.</p>" +
        "<p>This formulation places " + nt("Loi d’Or") + " at the point where proportion, rhythm and breath cease to be merely symbolic motifs and become a rule for the hold of the real. It serves as a reading axis to understand how an imbalance reattunes, how a tension remains alive without breaking, and how coherence is maintained through breathing rather than through fixity.</p>" +
        "<p>No guide-number proper to " + nt("Loi d’Or") + " is attested in the provided documents; the page therefore keeps only the two canonical ideograms available.</p>",
      h_features: "Attested dynamics",
      h_questions: "Usage markers",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "In a tense situation, Loi d’Or invites us to verify whether the sought equilibrium belongs to a simple immobilization or to a right breathing capable of keeping cohesion, passage and hold together.",
      features: [
        "Canonical family: X d’Or = principle, organ, operator.",
        "Attested function: law of syntony; all equilibrium is balanced breathing.",
        "Attested domain: ontological.",
        "Direct internal links: Souffle d’Or, Rythme d’Or, Mesure d’Or, within the matrix principles of K9."
      ],
      questions: [
        "What imbalance here calls for a breathing reattunement rather than a simple correction?",
        "Does the tension at stake concern rhythm, measure, passage or proportion?",
        "What minimal adjustment makes equilibrium breathable without freezing movement?",
        "Does the act increase the syntony of the field, or does it only mask the gap?"
      ],
      family_1: "<p><strong>Golden grammar:</strong> " + nt("Loi d’Or") + " belongs to the canonical form " + nt("X d’Or") + ", reserved for principles, organs and operators. In the K9 lexicon, this family names what acts as a unifying function or an instrument of coherence.</p>",
      family_2: "<p><strong>Internal links:</strong> within the matrix principles of K9, " + nt("Loi d’Or") + " stands alongside " + nt("Souffle d’Or") + ", " + nt("Rythme d’Or") + " and " + nt("Mesure d’Or") + ". It formulates their ontological rule: true equilibrium is maintained in adjusted breathing, at the crossing of φ, of 3–6–9 and of the syntony of Souffle.</p>",
      word_blocks: [
        { head: "1) Law", text: "Principle of hold, orientation and regulation of the real." },
        { head: "2) d’Or", text: "In K9’s golden grammar, this form designates an operator of coherence, an organ or a unifying principle." },
        { head: "3) Loi d’Or", text: "Canonical formula of a principle of syntony: equilibrium remains there breathing, adjustment and living continuity." }
      ],
      word_notes: [
        "Lexical status: gold_operator / Opérateurs.",
        "No guide-number proper to Loi d’Or is attested in the provided documents."
      ],
      cta_translate: "Suggest a translation of the concept",
      langbar_aria: "Language selection",
      audio_general: "Listen to the text",
      audio_block: "Listen to this block",
      audio_stop: "Stop playback"
    },
    ES: {
      title: "Loi d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Principios matriciales, gramática dorada y sintonía ontológica)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "En K9, " + "Loi d’Or" + " pertenece a la familia canónica " + "X d’Or" + ": un principio, un órgano o un operador. Se define explícitamente como ley de sintonía: “todo equilibrio es respiración equilibrada”.",
      def_long:
        "<p>En la gramática dorada vinculada a " + nt("Âṣẹxel’Or") + " y a " + nt("Souffle d’Or") + ", la forma canónica " + nt("X d’Or") + " nombra lo que actúa como principio, órgano u operador de coherencia. " + nt("Loi d’Or") + " pertenece a esta familia de operadores, y no a las cualidades del tipo " + nt("X doré(e)") + " ni a los regímenes del tipo " + nt("Or de X") + ".</p>" +
        "<p>En la tabla de los principios matriciales de " + nt("Katûpirsia 9") + ", " + nt("Loi d’Or") + " se da con su función posœnnoïal explícita: <em>ley de sintonía: todo equilibrio es respiración equilibrada</em>. Su dominio se precisa allí como ontológico.</p>" +
        "<p>Esta formulación sitúa " + nt("Loi d’Or") + " en el punto donde la proporción, el ritmo y el soplo dejan de ser solo motivos simbólicos para convertirse en una regla de sostenimiento de lo real. Sirve de eje de lectura para comprender cómo un desequilibrio se reajusta, cómo una tensión permanece viva sin romperse y cómo la coherencia se mantiene por respiración y no por fijeza.</p>" +
        "<p>Ningún número-guía propio de " + nt("Loi d’Or") + " está atestiguado en los documentos proporcionados; la página conserva por tanto solo los dos ideogramas canónicos disponibles.</p>",
      h_features: "Dinámicas atestiguadas",
      h_questions: "Puntos de uso",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "En una situación de tensión, Loi d’Or invita a verificar si el equilibrio buscado pertenece a una simple inmovilización o a una respiración justa capaz de mantener juntas cohesión, paso y sostén.",
      features: [
        "Familia canónica: X d’Or = principio, órgano, operador.",
        "Función atestiguada: ley de sintonía; todo equilibrio es respiración equilibrada.",
        "Dominio atestiguado: ontológico.",
        "Vínculos internos directos: Souffle d’Or, Rythme d’Or, Mesure d’Or, en el seno de los principios matriciales de K9."
      ],
      questions: [
        "¿Qué desequilibrio exige aquí un reajuste respirante más que una simple corrección?",
        "¿La tensión en juego pertenece al ritmo, a la medida, al paso o a la proporción?",
        "¿Qué ajuste mínimo vuelve respirable el equilibrio sin fijar el movimiento?",
        "¿El acto aumenta la sintonía del campo, o solo enmascara la brecha?"
      ],
      family_1: "<p><strong>Gramática dorada:</strong> " + nt("Loi d’Or") + " pertenece a la forma canónica " + nt("X d’Or") + ", reservada a principios, órganos y operadores. En el léxico K9, esta familia nombra aquello que actúa como función unificante o instrumento de coherencia.</p>",
      family_2: "<p><strong>Vínculos internos:</strong> en los principios matriciales de K9, " + nt("Loi d’Or") + " se sitúa junto a " + nt("Souffle d’Or") + ", " + nt("Rythme d’Or") + " y " + nt("Mesure d’Or") + ". Formula su regla ontológica: el equilibrio verdadero se mantiene en una respiración ajustada, en el cruce de φ, del 3–6–9 y de la sintonía de Souffle.</p>",
      word_blocks: [
        { head: "1) Ley", text: "Principio de sostén, orientación y regulación de lo real." },
        { head: "2) d’Or", text: "En la gramática dorada de K9, esta forma designa un operador de coherencia, un órgano o un principio unificante." },
        { head: "3) Loi d’Or", text: "Fórmula canónica de un principio de sintonía: el equilibrio permanece allí respiración, ajuste y continuidad viva." }
      ],
      word_notes: [
        "Estatuto léxico: gold_operator / Opérateurs.",
        "Ningún número-guía propio de Loi d’Or está atestiguado en los documentos proporcionados."
      ],
      cta_translate: "Proponer una traducción del concepto",
      langbar_aria: "Selección de idioma",
      audio_general: "Escuchar el texto",
      audio_block: "Escuchar este bloque",
      audio_stop: "Detener la lectura"
    }
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    if (src) el.setAttribute("src", clampStr(src));
    if (alt) el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    for (var i = 0; i < (items || []).length; i++){
      var li = document.createElement("li");
      li.textContent = clampStr(items[i]);
      el.appendChild(li);
    }
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    for (var i = 0; i < (blocks || []).length; i++){
      var b = blocks[i] || {};
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr(b.head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr(b.text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    }
  }

  function updateLangButtons(root, lang3){
    var buttons = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i = 0; i < buttons.length; i++){
      var btn = buttons[i];
      var active = normLang(btn.getAttribute("data-po-lang")) === lang3;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    }
    var bar = root.querySelector(".po-langbar");
    var C = COPY[lang3] || COPY.FR;
    if (bar) bar.setAttribute("aria-label", clampStr(C.langbar_aria || ""));
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new CustomEvent("po:locale-changed", { detail: { lang: readStoredLang() } }));
    }catch(e){
      try{
        var ev = document.createEvent("CustomEvent");
        ev.initCustomEvent("po:locale-changed", true, true, { lang: readStoredLang() });
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    isStopping: false
  };

  function audioUI(lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;
    return {
      general: C.audio_general,
      block: C.audio_block,
      stop: C.audio_stop
    };
  }

  function getSpeechLang(lang3){
    var L = normLang(lang3);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k9-loi-d-or-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k9-loi-d-or-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:flex-start;align-items:center;margin:10px 0 12px;}" +
      ".po-axis-audio-btn{" +
        "appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.66);" +
        "border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;font-weight:700;" +
        "letter-spacing:.02em;cursor:pointer;transition:all .18s ease;line-height:1.2;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.04);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(184,134,11,.08);border-color:rgba(184,134,11,.45);}" +
      ".po-axis-audio-btn[data-po-audio-kind='block']{margin-left:auto;flex:0 0 auto;}" +
      ".po-lex-summary{position:relative;}" +
      ".po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;min-width:0;}" +
      "@media (max-width:760px){.po-axis-audio-btn{font-size:11px;padding:7px 10px;}}";
    document.head.appendChild(style);
  }

  function stopAudio(){
    PO_AUDIO_STATE.isStopping = true;
    try{
      if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel();
    }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    clearPlayingButtons();
    setTimeout(function(){ PO_AUDIO_STATE.isStopping = false; }, 0);
  }

  function clearPlayingButtons(){
    var all = document.querySelectorAll(".po-axis-audio-btn.is-playing");
    for (var i = 0; i < all.length; i++) all[i].classList.remove("is-playing");
  }

  function setPlayingButtons(root, key){
    clearPlayingButtons();
    if (!root || !key) return;
    var btn = root.querySelector(".po-axis-audio-btn[data-po-audio-key='" + key + "']");
    if (btn) btn.classList.add("is-playing");
  }

  function cleanText(text){
    return clampStr(text)
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\s+([,.;:!?])/g, "$1")
      .trim();
  }

  function getNodeText(el){
    if (!el) return "";
    return cleanText(el.textContent || el.innerText || "");
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      if (el) parts.push(getNodeText(el));
    }
    return cleanText(parts.join(" "));
  }

  function collectBlockText(details){
    if (!details) return "";
    var parts = [];
    var summaryTitle = details.querySelector(".po-lex-summary__title");
    if (summaryTitle) parts.push(getNodeText(summaryTitle));

    var clone = details.cloneNode(true);
    var summary = clone.querySelector("summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    var buttons = clone.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < buttons.length; i++){
      if (buttons[i] && buttons[i].parentNode) buttons[i].parentNode.removeChild(buttons[i]);
    }
    parts.push(getNodeText(clone));
    return cleanText(parts.join(" "));
  }

  function splitSpeechText(text){
    var source = cleanText(text);
    if (!source) return [];
    var maxLen = 210;
    var out = [];
    var current = "";
    var segments = source.split(/(?<=[\.\!\?\:\;])\s+/);

    function pushCurrent(){
      current = cleanText(current);
      if (current) out.push(current);
      current = "";
    }

    for (var i = 0; i < segments.length; i++){
      var seg = cleanText(segments[i]);
      if (!seg) continue;
      if (!current){
        current = seg;
      } else if ((current + " " + seg).length <= maxLen){
        current += " " + seg;
      } else {
        pushCurrent();
        if (seg.length <= maxLen){
          current = seg;
        } else {
          var words = seg.split(/\s+/);
          var buffer = "";
          for (var j = 0; j < words.length; j++){
            var w = words[j];
            if (!buffer){
              buffer = w;
            } else if ((buffer + " " + w).length <= maxLen){
              buffer += " " + w;
            } else {
              out.push(cleanText(buffer));
              buffer = w;
            }
          }
          current = buffer;
        }
      }
    }
    pushCurrent();
    return out;
  }

  function createUtterance(text, lang3, onEnd){
    var u = new SpeechSynthesisUtterance(text);
    u.lang = getSpeechLang(lang3);
    u.rate = 1;
    u.pitch = 1;
    u.volume = 1;
    u.onend = function(){ if (typeof onEnd === "function") onEnd(); };
    u.onerror = function(){ if (typeof onEnd === "function") onEnd(); };
    return u;
  }

  function speakChunks(chunks, lang3, done){
    if (!PO_AUDIO_SYNTH || !chunks.length){
      if (typeof done === "function") done();
      return;
    }
    var idx = 0;
    function next(){
      if (PO_AUDIO_STATE.isStopping) return;
      if (idx >= chunks.length){
        if (typeof done === "function") done();
        return;
      }
      var utter = createUtterance(chunks[idx], lang3, function(){ idx += 1; next(); });
      try{ PO_AUDIO_SYNTH.speak(utter); }
      catch(e){ idx += 1; next(); }
    }
    next();
  }

  function buildUnits(root){
    var units = [];
    var generalText = collectGeneralText(root);
    if (generalText){
      units.push({
        key: "general",
        type: "general",
        node: root,
        getText: function(){ return collectGeneralText(root); }
      });
    }
    var blocks = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < blocks.length; i++){
      (function(index, details){
        units.push({
          key: "block-" + index,
          type: "block",
          node: details,
          getText: function(){ return collectBlockText(details); }
        });
      })(i, blocks[i]);
    }
    return units;
  }

  function playUnitSequence(root, startIndex){
    if (!root || !PO_AUDIO_SYNTH) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root);
    PO_AUDIO_STATE.unitPos = startIndex;
    if (startIndex < 0 || startIndex >= PO_AUDIO_STATE.units.length) return;

    function playCurrent(){
      if (PO_AUDIO_STATE.isStopping) return;
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      if (!unit){ stopAudio(); return; }

      if (unit.type === "block" && unit.node && !unit.node.open) unit.node.open = true;

      PO_AUDIO_STATE.activeKey = unit.key;
      setPlayingButtons(root, unit.key);

      var txt = cleanText(unit.getText());
      var chunks = splitSpeechText(txt);
      var lang3 = readStoredLang();

      if (!chunks.length){
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
        return;
      }

      speakChunks(chunks, lang3, function(){
        if (PO_AUDIO_STATE.isStopping) return;
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
      });
    }

    playCurrent();
  }

  function createAudioButton(kind, key){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    return btn;
  }

  function updateAudioButtonLabels(root, lang3){
    var ui = audioUI(lang3);
    var all = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < all.length; i++){
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind");
      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");
      btn.textContent = isPlaying ? ui.stop : (kind === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-label", btn.textContent);
      if (key === "general") btn.setAttribute("title", ui.general);
    }
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector(".po-lex-panel");
    if (!panel) return;

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", "general"));

      var meta = panel.querySelector(".po-axis-meta");
      var defShort = panel.querySelector("[data-po-slot='def_short']");
      var firstDetails = panel.querySelector(".po-lex-details");

      if (meta && meta.parentNode === panel && meta.nextSibling) panel.insertBefore(generalWrap, meta.nextSibling);
      else if (defShort && defShort.parentNode === panel) panel.insertBefore(generalWrap, defShort);
      else if (firstDetails && firstDetails.parentNode === panel) panel.insertBefore(generalWrap, firstDetails);
      else panel.appendChild(generalWrap);
    }

    var details = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < details.length; i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-kind='block']");
      if (!btn){
        btn = createAudioButton("block", "block-" + i);
        summary.appendChild(btn);
      } else {
        btn.setAttribute("data-po-audio-key", "block-" + i);
      }
    }
  }

  function bindAudioHandlers(root){
    if (!root || root.__poAudioBound) return;
    root.__poAudioBound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");

      if (isPlaying){
        stopAudio();
        updateAudioButtonLabels(root, readStoredLang());
        return;
      }

      var units = buildUnits(root);
      var startIndex = 0;
      for (var i = 0; i < units.length; i++){
        if (units[i].key === key){ startIndex = i; break; }
      }
      playUnitSequence(root, startIndex);
      updateAudioButtonLabels(root, readStoredLang());
    }, true);
  }

  function initAudioEverywhere(lang3){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioHandlers(roots[i]);
      updateAudioButtonLabels(roots[i], lang3);
    }
  }

  function render(root, lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;

    root.classList.add("notranslate");
    root.setAttribute("translate", "no");

    var scope = root.querySelector(".po-lex-scope[data-po-lex-scope]");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
    }

    setSlotText(root, "title", C.title);
    setSlotHTML(root, "kicker", C.kicker);
    setSlotImgSrc(root, "title_img", C.chip_urls[0], C.title);

    setSlotText(root, "h_def", C.h_def);
    setSlotText(root, "chip_1", C.chips[0]);
    setSlotText(root, "chip_2", C.chips[1]);
    setSlotImgSrc(root, "chip_1_img", C.chip_urls[0], C.chips[0]);
    setSlotImgSrc(root, "chip_2_img", C.chip_urls[1], C.chips[1]);

    setSlotText(root, "def_short", C.def_short);
    setSlotHTML(root, "def_long", C.def_long);

    setSlotText(root, "h_features", C.h_features);
    setSlotText(root, "h_questions", C.h_questions);
    setSlotText(root, "h_family", C.h_family);
    setSlotText(root, "h_wordbuild", C.h_wordbuild);
    setSlotText(root, "hint_fold", C.hint_fold);
    setSlotText(root, "hint_fold2", C.hint_fold);
    setSlotText(root, "hint_fold3", C.hint_fold);
    setSlotText(root, "hint_fold4", C.hint_fold);

    renderListInto(root, "features", C.features);
    renderListInto(root, "questions", C.questions);
    setSlotHTML(root, "example_box", "<div><strong>" + C.example_title + "</strong> " + C.example + "</div>");
    setSlotHTML(root, "family_1", C.family_1);
    setSlotHTML(root, "family_2", C.family_2);
    renderWordBlocks(root, "wordbuild_blocks", C.word_blocks);
    renderListInto(root, "wordbuild_notes", C.word_notes);
    setSlotText(root, "cta_translate", C.cta_translate);

    updateLangButtons(root, normLang(lang3));
  }

  function applyLangEverywhere(lang3){
    lang3 = normLang(lang3);
    storeLang(lang3);
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) render(roots[i], lang3);
    initAudioEverywhere(lang3);
    notifyLocaleChanged();
  }

  function wireLangButtons(root){
    var bar = root.querySelector(".po-langbar");
    if (!bar || bar.__poLangBound) return;
    bar.__poLangBound = true;

    bar.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-langbtn[data-po-lang]") : null;
      if (!btn) return;
      ev.preventDefault();
      applyLangEverywhere(btn.getAttribute("data-po-lang") || "FR");
    });
  }

  function init(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) wireLangButtons(roots[i]);
    applyLangEverywhere(readStoredLang());
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoK9LoiDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: readStoredLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
